import type { DichVuInput } from '@/types/schemas';
import type { ImportBody } from './excel-import';

export const buildDichVuPayload = (body: ImportBody, action: 'NEW' | 'EDIT', entityModel: string): DichVuInput => ({
  entity_model: entityModel,
  action,
  ma_dv: body.ma_dv,
  ten_dv: body.ten_dv,
  ten_dv2: body.ten_dv2 ?? '',
  dvt: body.dvt ?? '',
  tk_dt: body.tk_dt ?? '',
  tk_cp: body.tk_cp ?? '',
  ma_thue: body.ma_thue ?? '',
  gia_nt2: body.gia_nt2 ?? 0,
  gia_nt: body.gia_nt ?? 0,
  ma_cp: body.ma_cp ?? '',
  ma_phi: body.ma_phi ?? '',
  ma_bp: body.ma_bp ?? '',
  ma_hd: body.ma_hd ?? '',
  ma_ku: body.ma_ku ?? '',
  ma_vv: body.ma_vv ?? '',
  status: body.status ?? 1
});
